import InitialData from './getInitialData/InitialData';
import { ApiErrorCode } from './ApiErrorCode';
import { CustomPropertiesResult } from './customProperties/CustomPropertiesResult';
import { EwsProxyAsyncResult } from './ews/EwsProxyAsyncResult';
import { SsoErrorCode } from 'owa-addins-sso';
import { TokenAsyncResult } from './token/TokenAsyncResult';

export enum ApiMethodResultStatus {
    Success = 0,
    Failed = 1,
}

export interface ApiMethodCallback {
    (asyncResult: ApiMethodResponse): void;
}

export type ApiMethodResponse =
    | ApiMethodResult
    | EwsProxyAsyncResult
    | InitialData
    | TokenAsyncResult
    | CustomPropertiesResult;

export interface ApiMethodResult {
    error: ApiMethodResultStatus;
    data?: any;
    errorCode?: ApiErrorCode | SsoErrorCode;
}
